export const isCallNotification = (message) => {
    return message.method !== undefined && message.method === 'call';
};
//# sourceMappingURL=call-notification.js.map